import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from '../utils/propTypes';

const RedirectToQuality = ({ partialURL }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    navigate(`/app/project/${id}/quality/${partialURL}`);
  }, [id, navigate, partialURL]);

  return null;
};

RedirectToQuality.propTypes = {
  partialURL: PropTypes.string.isRequired,
};

export default RedirectToQuality;
